import React, { ReactNode, ReactElement } from 'react';

interface CommandBarProps {
  children?: ReactNode;
}

export const CommandBar = ({ children }: CommandBarProps): ReactElement<CommandBarProps> => {
  return <div className="command-bar">{children}</div>;
};
